import React, { useEffect, useState } from 'react';

import { useGetLivestreamingTopCountriesQuery } from '../../redux/apis/analyticsManagement/aMLiveStreamingStatsApiSlice';
import HeatMap from '../other/charts/HeatMap';
import ComponentLoader from '../other/ComponentLoader';
import { Card, CardBody, CardExpandToggler } from '../other/card/card';

const HEATMAP_HEIGHT = 380;

const LiveStreamingTopCountries = () => {
  const { data, isLoading, isError, error } = useGetLivestreamingTopCountriesQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [chartThemeKey, setChartThemeKey] = useState(0);

  useEffect(() => {
    const onThemeReload = () => setChartThemeKey(k => k + 1);
    document.addEventListener('theme-reload', onThemeReload);
    return () => document.removeEventListener('theme-reload', onThemeReload);
  }, []);

  const items = Array.isArray(data) ? data : [];
  const hasNumeric = items.filter(item => item.code && typeof item.value === 'number').length > 0;

  return (
    <div className='row g-2 mt-1'>
      <div className='col-12'>
        <Card className='mb-0'>
          <CardBody className='relative p-0'>
            {isError ? (
              <div className='absolute inset-0 d-flex items-center justify-center p-3 text-danger small bg-white bg-opacity-75'>
                Failed to load.
                {error?.data?.message ? ` ${error.data.message}` : ''}
              </div>
            ) : null}

            <div className='p-4 d-flex flex-wrap justify-content-between gap-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex fw-bold small'>Overall Streams Per Hosting Country For Current Year</div>
              </div>
              <div className='align-self-start'>
                <CardExpandToggler />
              </div>
            </div>

            <div className='p-4 pt-0'>
              <div className='small text-body-secondary'>
                <div className='mt-2 position-relative' style={{ minHeight: HEATMAP_HEIGHT }}>
                  {isLoading ? <ComponentLoader /> : null}
                  {hasNumeric ? (
                    <HeatMap
                      key={`ls-countries-${chartThemeKey}`}
                      items={items}
                      height={HEATMAP_HEIGHT}
                      mapId='livestreaming-countries-heatmap'
                    />
                  ) : !isLoading ? (
                    <div
                      className='d-flex align-items-center justify-content-center text-center px-2'
                      style={{ minHeight: HEATMAP_HEIGHT }}
                    >
                      No country data for this period.
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default LiveStreamingTopCountries;
